/**
 * Tipo de documento fiscal del listado (D14/D15): factura completa o ticket de venta
 * (factura simplificada). Los tickets viven en la misma tabla y en el mismo listado que
 * las facturas — el tipo solo cambia la etiqueta que se muestra y, en el backend, el
 * endpoint de Holded del que se descarga el PDF.
 */
export type InvoiceDocumentType = 'invoice' | 'ticket';

/**
 * Entidad Invoice (frontend) — documento fiscal descargable de la organización autenticada.
 *
 * Molde: `Organization.ts`. Los campos primitivos vienen ya mapeados por el backend
 * (`GET /v2/organizations/invoices`) — el filtrado por estado descargable y el guard IDOR
 * viven en el dominio backend (`src/organization/billing/`), no aquí.
 *
 * `documentType` es OPCIONAL a propósito (D15): un backend anterior al despliegue de este
 * change no lo envía, y durante la ventana de despliegue el frontend nuevo convive con él.
 * El consumidor lo trata como `'invoice'` cuando falta.
 */
export class Invoice {
  constructor(
    public readonly id: string,
    public readonly date: string,
    public readonly concept: string,
    public readonly amount: number,
    public readonly currency: string,
    public readonly documentType?: InvoiceDocumentType
  ) {}

  static fromPrimitives(data: {
    id: string;
    date: string;
    concept: string;
    amount: number;
    currency: string;
    documentType?: InvoiceDocumentType;
  }): Invoice {
    return new Invoice(data.id, data.date, data.concept, data.amount, data.currency, data.documentType);
  }
}
